import { useEffect } from "react";

const DEFAULT_TITLE = "CozyHome — Rénovation, aménagement & construction | Vesoul, Haute-Saône";
const DEFAULT_DESC =
  "CozyHome — Rénovation, aménagement, extension et construction. Un seul accompagnement pour simplifier tout votre projet, de l'idée à la réception des travaux. Vesoul et alentours, Haute-Saône.";

/** Met à jour le title et la meta description de la page, puis restaure les valeurs du site au démontage. */
export const useDocumentMeta = (title, description) => {
  useEffect(() => {
    const meta = document.querySelector('meta[name="description"]');
    document.title = title;
    if (meta && description) meta.setAttribute("content", description);
    return () => {
      document.title = DEFAULT_TITLE;
      if (meta) meta.setAttribute("content", DEFAULT_DESC);
    };
  }, [title, description]);
};
